import { AUDIO_PLAYBACK_RATE_CACHE_KEY, DEFAULT_PLAYBACK_RATE } from '../config';

const MIN_PLAYBACK_RATE = 0.25;
const MAX_PLAYBACK_RATE = 4;
// Levels used to play slower or faster than their labels (e.g. "1.5X" at 1.4); a rate saved back then maps to
// the level it was shown as
const LEGACY_PLAYBACK_RATES: Record<number, number> = {
  0.66: 0.5,
  0.8: 0.75,
  1.4: 1.5,
  1.8: 2,
};

export function migrateAudioPlaybackRate(rate: number) {
  return LEGACY_PLAYBACK_RATES[rate] ?? rate;
}

// `undefined` means nothing was saved yet, so the caller can fall back to the rate kept in the global cache
export function readStoredAudioPlaybackRate() {
  let raw: string | undefined;
  try {
    raw = localStorage.getItem(AUDIO_PLAYBACK_RATE_CACHE_KEY) ?? undefined;
  } catch {
    return undefined;
  }
  if (raw === undefined) return undefined;

  const rate = Number(raw);
  const isValid = Number.isFinite(rate) && rate >= MIN_PLAYBACK_RATE && rate <= MAX_PLAYBACK_RATE;
  return isValid ? rate : DEFAULT_PLAYBACK_RATE;
}

export function storeAudioPlaybackRate(rate: number) {
  try {
    localStorage.setItem(AUDIO_PLAYBACK_RATE_CACHE_KEY, String(rate));
  } catch {
    // Storage is unavailable in a private window or with blocked site data; the global cache still keeps the rate
  }
}
